import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Service
} from '../models';

import {
  getAuthHeaders
} from '../app/app.utils';

import {
  _SERVER_URL,
  _WMS_URL
} from '../app/app.const';

@Injectable()
export class ServiceService {
  public authToken: string;
  
  constructor(
    private http: HttpClient
  ) {}

  public get(
    _id: string,
    isWms: boolean = false
  ): Promise<Service> {
    return (
      <any>(
        this.http
            .get(
              `${!isWms ? _SERVER_URL : _WMS_URL}api/services/${_id}`,
              getAuthHeaders(
                this.authToken
              )
            )
            .toPromise()
      )
    );
  }
  
  public getAll(
    isWms: boolean = false
  ): (
    Promise<Service[]>
  ) {
    return (
      <any>(
        this.http
            .get(
              `${!isWms ? _SERVER_URL : _WMS_URL}api/services`,
              getAuthHeaders(
                this.authToken
              )
            )
            .toPromise()
      )
    );
  }
}